<template>
  <section class="px-4 py-3 space-y-6">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-lg font-normal">Maintenance des projets</h1>
      <div class="flex items-center gap-4">
        <!-- Filtre -->
        <div class="relative">
          <select v-model="filterStatus"
                  class="border border-gray-300 rounded-md px-8 py-1 text-sm text-gray-700 appearance-none">
            <option value="All">Tous</option>
            <option value="Actif">Actifs</option>
            <option value="Inactif">Inactifs</option>
          </select>
          <svg xmlns="http://www.w3.org/2000/svg"
               class="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500 pointer-events-none"
               fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2l-6 6v6l-4 4v-10L3 6V4z"/>
          </svg>
        </div>

        <!-- Bouton Ajouter Projet -->
        <button @click="showAddModal = true"
                class="text-sm font-normal text-gray-900 bg-white border border-gray-300 rounded-md px-3 py-1 hover:bg-gray-50"
                type="button">
          Ajouter un projet
        </button>
      </div>
    </div>

    <!-- Cards -->
    <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
      <!-- Card: Total -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Total</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M21 10.5v6.75A2.25 2.25 0 0 1 18.75 19.5H5.25A2.25 2.25 0 0 1 3 17.25V6.75A2.25 2.25 0 0 1 5.25 4.5H12"/>
              <path stroke-width="1.5" d="M21 10.5H14.25A2.25 2.25 0 0 1 12 8.25V4.5L21 10.5Z"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ Total }} €</div>
        </div>
      </div>

      <!-- Card: Maintenance Active -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Maintenance Active</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M3 7.5 12 13.5 21 7.5"/>
              <rect x="3" y="5.25" width="18" height="13.5" rx="2.25" stroke-width="1.5"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ Maintenance_Active }}</div>
        </div>
      </div>

      <!-- Card: Intervention -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Intervention</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M7.5 8.25h9M7.5 12h6M4.5 19.5l3.75-3.75h9.75A2.25 2.25 0 0 0 20.25 13.5V6.75A2.25 2.25 0 0 0 18 4.5H6A2.25 2.25 0 0 0 3.75 6.75v9"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ Intervention }}</div>
        </div>
      </div>

      <!-- Card: Conversion -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Conversion Maintenance</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M3 12l4-4 4 4 6-6"/>
              <path stroke-width="1.5" d="M17 6h4v4"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-center justify-between">
          <div class="flex items-baseline gap-2">
            <div class="text-3xl font-semibold text-gray-900">{{ Conversion }} %</div>
          </div>
          <span
            class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium"
            :class="ticketsGrowth >= 0 ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'"
          >
            <svg v-if="ticketsGrowth >= 0" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6-6 6 6"/>
            </svg>
            <svg v-else class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6 6 6-6"/>
            </svg>
            <span>{{ ticketsGrowth >= 0 ? 'En hausse' : 'En baisse' }}</span>
          </span>
        </div>
      </div>
    </div>

    <!-- Tableau des projets -->
    <div class="overflow-x-auto bg-white shadow-sm rounded-2xl border border-gray-100">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Catégorie</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Projet</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Statut</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Montant</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Responsable</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Dernière intervention</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Timeline</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="projet in filteredProjets" :key="projet.id">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ projet.categorie || '—' }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ projet.nom }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="statusClass(projet.status)">
                {{ projet.status }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{{ projet.montant || '—' }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ projet.responsable }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ projet.derniereIntervention }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ projet.timeline }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm flex gap-2">
              <button @click="voirProjet(projet)" class="p-2 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition" title="Voir">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7s-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

<!-- Modal Modifier Projet -->
<div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
  <div class="bg-white rounded-xl w-full max-w-2xl p-6 space-y-4 relative">
    <h2 class="text-lg font-semibold text-gray-800">Modifier le projet</h2>
    <button @click="showModal = false" class="absolute top-3 right-3 text-gray-400 hover:text-gray-600">&times;</button>

    <div class="space-y-4">
      <!-- Projet associé -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Projet associé</label>
        <select
          v-model="selectedProjet.nom"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>-- Sélectionner un projet --</option>
          <option v-for="projet in projetsList" :key="projet.id" :value="projet.nom">{{ projet.nom }}</option>
        </select>
      </div>
      <hr />

      <!-- Montant -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Montant maintenance</label>
        <input
          v-model="selectedProjet.montant"
          type="number"
          placeholder="Montant €"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <hr />

      <!-- Catégorie -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Catégorie</label>
        <select
          v-model="selectedProjet.categorie"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>-- Sélectionner une catégorie --</option>
          <option v-for="cat in categoriesList" :key="cat._id" :value="cat.nom">{{ cat.nom }}</option>
        </select>
      </div>
      <hr />

      <!-- Statut -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Statut</label>
        <select
          v-model="selectedProjet.status"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="Actif">Actif</option>
          <option value="Inactif">Inactif</option>
          <option value="En attente">En attente</option>
        </select>
      </div>
      <hr />

      <!-- Type de facturation -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Type de facturation</label>
        <select
          v-model="selectedProjet.facturation"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="Mensuel">Mensuel</option>
          <option value="Annuel">Annuel</option>
        </select>
      </div>
      <hr />

      <!-- Durée d'engagement -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Durée d'engagement</label>
        <select
          v-model="selectedProjet.engagement"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="Sans engagement">Sans engagement</option>
          <option value="6 mois">6 mois</option>
          <option value="12 mois">12 mois</option>
          <option value="24 mois">24 mois</option>
        </select>
      </div>
      <hr />

      <!-- Renouvellement -->
      <div class="flex items-center gap-2">
        <input v-model="selectedProjet.renouvellementAuto" type="checkbox" id="renouvellement" class="w-4 h-4"/>
        <label for="renouvellement" class="text-sm text-gray-700">Renouvellement automatique</label>
      </div>

      <!-- Services -->
      <div class="flex items-start justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm mt-1">Services</label>
        <textarea
          v-model="selectedProjet.services"
          placeholder="Décrire les services apportés"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          rows="4"
        ></textarea>
      </div>
    </div>

    <!-- Boutons -->
    <div class="flex justify-end space-x-2 mt-4">
      <button @click="showModal = false" class="px-4 py-2 text-gray-700 border rounded hover:bg-gray-100">Annuler</button>
      <button @click="updateProjet(selectedProjet)" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Enregistrer</button>
    </div>
  </div>
</div>


<!-- Modal Ajouter Projet -->
<div v-if="showAddModal" class="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
  <div class="bg-white rounded-xl w-full max-w-2xl p-6 space-y-4 relative">
    <h2 class="text-lg font-semibold text-gray-800">Créer une Maintenance</h2>
    <button @click="showAddModal = false" class="absolute top-3 right-3 text-gray-400 hover:text-gray-600">&times;</button>

    <div class="space-y-4">
      <!-- Projet associé -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Projet associé</label>
        <select
          v-model="newProjet.nom"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>-- Sélectionner un projet --</option>
          <option v-for="projet in projetsList" :key="projet.id" :value="projet.nom">{{ projet.nom }}</option>
        </select>
      </div>
      <hr />

      <!-- Montant maintenance -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Montant maintenance</label>
        <input
          v-model="newProjet.montant"
          type="number"
          placeholder="Montant €"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <hr />

      <!-- Catégorie -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Catégorie</label>
        <select
          v-model="newProjet.categorie"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>-- Sélectionner une catégorie --</option>
          <option v-for="cat in categoriesList" :key="cat._id" :value="cat.nom">{{ cat.nom }}</option>
        </select>
      </div>
      <hr />

      <!-- Statut -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Statut</label>
        <select
          v-model="newProjet.status"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>-- Sélectionner un statut --</option>
          <option value="Actif">Actif</option>
          <option value="Inactif">Inactif</option>
          <option value="En attente">En attente</option>
        </select>
      </div>
      <hr />

      <!-- Type de facturation -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Type de facturation</label>
        <select
          v-model="newProjet.facturation"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>-- Choisir --</option>
          <option value="Mensuel">Mensuel</option>
          <option value="Annuel">Annuel</option>
        </select>
      </div>
      <hr />

      <!-- Durée d'engagement -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Durée d'engagement</label>
        <select
          v-model="newProjet.engagement"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="Sans engagement">Sans engagement</option>
          <option value="6 mois">6 mois</option>
          <option value="12 mois">12 mois</option>
          <option value="24 mois">24 mois</option>
        </select>
      </div>
      <hr />

      <!-- Renouvellement automatique -->
      <div class="flex items-center gap-2">
        <input v-model="newProjet.renouvellementAuto" type="checkbox" id="renouvellement" class="w-4 h-4"/>
        <label for="renouvellement" class="text-sm text-gray-700">Renouvellement automatique</label>
      </div>

      <!-- Services (textarea) -->
      <div class="flex items-start justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm mt-1">Services</label>
        <textarea
          v-model="newProjet.services"
          placeholder="Décrire les services apportés"
          class="w-2/3 border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows="4"
        ></textarea>
      </div>
    </div>

    <!-- Boutons -->
    <div class="flex justify-end space-x-2 mt-4">
      <button @click="showAddModal = false" class="px-4 py-2 text-gray-700 border rounded hover:bg-gray-100">Annuler</button>
      <button @click="ajouterProjet" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Créer</button>
    </div>
  </div>
</div>



  </section>
</template>

<script>
export default {
  data() {
    return {
      filterStatus: "All",
      showModal: false,
      showAddModal: false,
      selectedProjet: {},
      newProjet: {
        nom: '',
        montant: '',
        timeline: '',
        renouvellementAuto: false,
        services: []
      },
      availableServices: ["Sauvegarde", "Audit sécurité", "Optimisation", "Maintenance serveur"],
projets: [
  {
    id: 1,
    categorie: "Serveur",
    projetAssocie: "Infrastructure IT",
    nom: "Migration serveur",
    status: "Actif",
    montant: "1500",
    priorite: "Haute",
    responsable: "Enzo Viana",
    derniereIntervention: "2025-08-30",
    facturation: "Mensuel",
    engagement: "12 mois",
    renouvellementAuto: true,
    services: "Sauvegarde complète, Test de migration, Optimisation",
  },
  {
    id: 2,
    categorie: "Sécurité",
    projetAssocie: "Audit global",
    nom: "Audit sécurité",
    status: "Inactif",
    montant: "800",
    priorite: "Moyenne",
    responsable: "Audrey Godart",
    derniereIntervention: "2025-08-25",
    facturation: "Annuel",
    engagement: "Sans engagement",
    renouvellementAuto: false,
    services: "Scan vulnérabilités, Rapport complet",
  },
  {
    id: 3,
    categorie: "Réseau",
    projetAssocie: "Optimisation SI",
    nom: "Optimisation réseau",
    status: "En attente",
    montant: "1200",
    priorite: "Haute",
    responsable: "Lucas Martin",
    derniereIntervention: "2025-08-20",
    facturation: "Mensuel",
    engagement: "6 mois",
    renouvellementAuto: true,
    services: "Analyse trafic, Réorganisation VLAN, Sécurisation accès",
  },
  {
    id: 4,
    categorie: "Application",
    projetAssocie: "Portail Client B2B",
    nom: "Développement portail client",
    status: "Actif",
    montant: "3000",
    priorite: "Critique",
    responsable: "Sarah Lopez",
    derniereIntervention: "2025-08-28",
    facturation: "Annuel",
    engagement: "24 mois",
    renouvellementAuto: true,
    services: "UI/UX Design, Backend API, Déploiement cloud",
  },
],

      Total: 2000,
      Maintenance_Active: 10,
      Intervention: 0,
      Conversion: 90,
      ticketsGrowth: 5
    };
  },
  computed: {
    filteredProjets() {
      if (this.filterStatus === "All") return this.projets;
      return this.projets.filter(projet => projet.status === this.filterStatus);
    }
  },
  methods: {
    statusClass(status) {
      switch (status) {
        case "Actif": return "bg-green-100 text-green-800";
        case "Inactif": return "bg-red-100 text-red-800";
        case "En attente de paiement": return "bg-orange-100 text-orange-800";
        default: return "bg-gray-100 text-gray-800";
      }
    },
    voirProjet(projet) {
      this.selectedProjet = projet;
      this.showModal = true;
    },
    ajouterProjet() {
      const id = this.projets.length + 1;
      this.projets.push({ id, categorie: '', status: "Actif", responsable: "Non assigné", derniereIntervention: "-", prestations: [], ...this.newProjet });
      this.showAddModal = false;
      this.newProjet = { nom: '', montant: '', timeline: '', renouvellementAuto: false, services: [] };
    }
  }
};
</script>
